/* eslint-disable no-nested-ternary */
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";

import AdminDashBoard from "./AdminDashBoard";
import CustomerDashBoard from "./CustomerDashBoardV2";
import EmployeeDashboardV3 from "./EmployeeDashboardV3";
import EmployeeDashboardV2 from "./EmployeeDashboardV2";
import { usePermissions } from "components/Hook";

import { DropdownData } from "store/actions/DropdownData";
import { useFlags } from "launchdarkly-react-client-sdk";

function Dashboard() {
  const dispatch = useDispatch();
  const { checkInRevamped } = useFlags();
  const { loggedInUserType } = usePermissions();

  useEffect(() => {
    dispatch(DropdownData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>Edge | Dashboard</title>
      </Helmet>
      {loggedInUserType === "edge" ? (
        <AdminDashBoard />
      ) : loggedInUserType === "customer" ? (
        <CustomerDashBoard />
      ) : loggedInUserType === "employee" ? (
        checkInRevamped ? (
          <EmployeeDashboardV3 />
        ) : (
          <EmployeeDashboardV2 />
        )
      ) : null}
    </>
  );
}

export default Dashboard;
